export default function validateIBAN(value: string | undefined) {
  if (!value) {
    return false;
  }

  value = value.replace(/\s/g, '');

  if (!/^NL\d{2}[A-Z]{4}\d{10}$/.test(value)) {
    return false;
  }

  value = value.replace(/^(.{4})(.*)$/, '$2$1');
  value = value.replace(/[A-Z]/g, (e) => (e.charCodeAt(0) - 'A'.charCodeAt(0) + 10).toString());

  let sum = 0;
  let exponent = 1;

  for (let i = value.length - 1; i >= 0; i--) {
    sum += exponent * parseInt(value.charAt(i), 10);
    exponent = (exponent * 10) % 97;
  }

  return sum % 97 === 1;
}
